export default __webpack_public_path__ + "static/media/made-easy-3.6674ccad.png";